export class OfferTypesConstants {
  public static TOKEN: string = "TOKEN.NOVA";
  public static VIRTUAL: string = "VIRTUAL.NOVA";
}
